import { render } from "./Evaluation3.vue?vue&type=template&id=48519ae3"
import script from "./Evaluation3.vue?vue&type=script&lang=js"
export * from "./Evaluation3.vue?vue&type=script&lang=js"
script.render = render

export default script